export default __webpack_public_path__ + "media/images/app-icon-3748434b78a616e3dc3fab0592aa8f02.svg";